// @ts-nocheck — TODO: tipizzare (S6) — vedi cast HTMLInputElement
// ====== F7: Filtri server-side per audit log ======
// Sostituisce il filtraggio client su 200 voci con query server filtrata
// per data/utente/azione/target. Mantiene paginazione cursor-based su `ts`.
//
// API:
//   loadAuditFiltered({ from, to, user, action, target, pageSize }) -> Promise<entries[]>
//   appendAuditFiltered(opts) -> aggiunge la pagina successiva alla coda

const _auditServerState = {
  lastFilters: null,
  cursor: null,
  exhausted: false
};

/**
 * @param {{ from?: string, to?: string, user?: string, action?: string, target?: string, pageSize?: number }} f
 */
async function loadAuditFiltered(f = {}, append = false) {
  // @ts-ignore — isAdmin globale
  if (!isAdmin()) return [];
  const pageSize = Math.min(500, Math.max(10, f.pageSize || 200));

  // Reset cursore se filtro nuovo
  if (!append || JSON.stringify(_auditServerState.lastFilters) !== JSON.stringify(f)) {
    _auditServerState.lastFilters = { ...f };
    _auditServerState.cursor = null;
    _auditServerState.exhausted = false;
  }
  if (_auditServerState.exhausted) return [];

  // @ts-ignore — sb globale
  let q = sb.from('audit_log').select('*').order('ts', { ascending: false }).limit(pageSize);
  if (f.from) q = q.gte('ts', f.from);
  if (f.to) {
    // Includi tutto il giorno: aggiungi 23:59:59
    const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(f.to);
    q = q.lte('ts', isDateOnly ? f.to + 'T23:59:59.999Z' : f.to);
  }
  if (f.user) q = q.eq('user_name', f.user);
  if (f.action) q = q.eq('action', f.action);
  if (f.target) q = q.ilike('target', `%${f.target}%`);
  if (_auditServerState.cursor) q = q.lt('ts', _auditServerState.cursor);

  const { data, error } = await q;
  if (error) {
    console.error('audit server filter error', error);
    throw error;
  }
  const rows = (data || []).map((a) => ({
    id: a.id,
    timestamp: a.ts,
    user: a.user_name || 'Sistema',
    action: a.action,
    entity: a.entity || '',
    target: a.target || '',
    details: a.details || '',
    changes: Array.isArray(a.changes) ? a.changes : [],
    ip: a.ip || '',
    userAgent: a.user_agent || ''
  }));
  if (rows.length) _auditServerState.cursor = rows[rows.length - 1].timestamp;
  if (rows.length < pageSize) _auditServerState.exhausted = true;

  if (!append) {
    // @ts-ignore — state globale
    state.auditLog = rows;
  } else {
    // @ts-ignore
    state.auditLog.push(...rows);
  }
  return rows;
}

/** Stato esaurito? (per il pulsante "Carica altri"). */
function isAuditExhausted() {
  return _auditServerState.exhausted;
}

function resetAuditServer() {
  _auditServerState.lastFilters = null;
  _auditServerState.cursor = null;
  _auditServerState.exhausted = false;
}

// Aggancia automaticamente i filtri (se gli input esistono): from / to / user / action.
// Mantiene `renderStorico` esistente come renderer.
function wireServerFilters() {
  const inputs = [
    'filterStoricoFrom',
    'filterStoricoTo',
    'filterStoricoAction',
    'filterStoricoUser',
    'filterStoricoCliente'
  ];
  inputs.forEach((id) => {
    const el = document.getElementById(id);
    if (!el || el.dataset.serverFilterWired === '1') return;
    el.dataset.serverFilterWired = '1';
    const event = el.tagName === 'INPUT' && el.type !== 'date' ? 'input' : 'change';
    let t;
    el.addEventListener(event, () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        const f = {
          from: document.getElementById('filterStoricoFrom')?.value || undefined,
          to: document.getElementById('filterStoricoTo')?.value || undefined,
          user: document.getElementById('filterStoricoUser')?.value || undefined,
          action: document.getElementById('filterStoricoAction')?.value || undefined,
          target: document.getElementById('filterStoricoCliente')?.value || undefined
        };
        // Skip server hit se tutti i filtri vuoti (lascia la modalità classica)
        if (!Object.values(f).some(Boolean)) return;
        try {
          await loadAuditFiltered(f, false);
          // @ts-ignore — renderStorico globale
          if (typeof renderStorico === 'function') renderStorico();
        } catch (_) {
          /* silent */
        }
      }, 280);
    });
  });
}

document.addEventListener('DOMContentLoaded', wireServerFilters);

// @ts-ignore — global
Object.assign(globalThis, {
  loadAuditFiltered,
  resetAuditServer,
  isAuditExhausted,
  wireAuditServerFilters: wireServerFilters
});
export {};
